import PropTypes from 'prop-types'
import classify from 'underscore.string/classify'
import classNames from 'classnames'
import React, { Component } from 'react'
import ImageHelper from 'base/lib/image_helper'
import HidePIIFromTrackers from 'base/components/hide_pii_from_trackers'

class Input extends Component {
  static propTypes = {
    value: PropTypes.any,
    wrapperClass: PropTypes.string,
    inputClass: PropTypes.string,
    labelClass: PropTypes.string,
    errorClass: PropTypes.string,
    error: PropTypes.string,
    altText: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    labelPosition: PropTypes.oneOf(['left', 'right']),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    labelVerticalPosition: PropTypes.oneOf(['top', 'bottom']),
    errorPosition: PropTypes.oneOf(['top', 'bottom']),
    pattern: PropTypes.string,
    autocomplete: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    name: PropTypes.string,
    warningMessage: PropTypes.string,
  }

  static defaultProps = {
    wrapperClass: '',
    inputClass: '',
    labelClass: '',
    errorClass: '',
    altText: '',
    labelPosition: 'left',
    labelVerticalPosition: 'top',
    errorPosition: 'top',
    style: {},
    onChange: () => false,
  }

  getValue() {
    return this.inputRef.value
  }

  getInputRef() {
    return this.inputRef
  }

  handleCheckboxToggle = event => {
    event.preventDefault()
    const dummyEvent = {
      target: { checked: !this.props.value },
      preventDefault: () => {},
    }
    return typeof this.props.onChange === 'function' ? this.props.onChange(dummyEvent) : undefined
  }

  render() {
    let ariaLabel
    const nameAttr = classify(this.props.label).toLowerCase()

    // Accessiblity
    if (!this.props.label) {
      ariaLabel = this.props.name
    }

    const inputClassNames = classNames('form__input', {
      'form__input--select': this.props.type === 'select',
      'form__input--text-area': this.props.type === 'textarea',
      'form__input--inline': this.props.type === 'checkbox',
      'form__input--inline': this.props.type === 'checkbox-dark',
      'form__input--block': !['checkbox', 'radio'].includes(this.props.type),
      'form__input--left': this.props.labelPosition === 'left',
      'form__input--right': this.props.labelPosition === 'right',
      'form__input--error-state': this.props.error != null,
      'form__input--disabled': this.props.disabled,
      [this.props.inputClass]: this.props.inputClass != null,
    })

    const labelClassNames = classNames('form__input-label', {
      'form__input-label--inline': ['radio', 'checkbox', 'checkbox-dark'].includes(this.props.type),
      'form__input-label--block': !['radio', 'checkbox', 'checkbox-dark'].includes(this.props.type),
      'form__input-label--left': this.props.labelPosition === 'left',
      'form__input-label--left-flex': this.props.labelPosition === 'left-flex',
      'form__input-label--right': this.props.labelPosition === 'right',
      'form__input-label--checkbox': this.props.type === 'checkbox',
      'form__input-label--checkbox': this.props.type === 'checkbox-dark',
      'form__input-label--disabled': this.props.disabled,
      [this.props.labelClass]: this.props.labelClass != null,
    })

    const fieldsetClassNames = classNames('form__input-group', {
      'form__input-group--radio': this.props.type === 'radio',
      'form__input-group--block': this.props.type !== 'radio',
      [this.props.wrapperClass]: this.props.wrapperClass != null,
    })

    const errorClassNames = classNames('form__error', {
      [this.props.errorClass]: this.props.errorClass != null,
    })

    const input =
      this.props.type === 'select' ? (
        <select
          disabled={this.props.disabled}
          value={this.props.value}
          name={this.props.name || nameAttr}
          ref={el => (this.inputRef = el)}
          id={nameAttr}
          className={inputClassNames}
          onChange={this.props.onChange}
          aria-label={ariaLabel}
        >
          {this.props.children}
        </select>
      ) : this.props.type === 'checkbox' ? (
        this.props.value ? (
          <span>
            <div className="form__checkbox--active" onClick={this.handleCheckboxToggle}>
              <img
                className="form__checkbox-checkmark"
                src={ImageHelper.imageUrl('i/768509f9_9371.svg')}
                alt={this.props.altText}
              />
            </div>
            <input
              placeholder={this.props.placeholder}
              checked
              value={this.props.value}
              title={this.props.title}
              name={this.props.name || nameAttr}
              ref={el => (this.inputRef = el)}
              className="form__actual-checkbox"
              aria-label={ariaLabel}
              disabled={this.props.disabled}
            />
          </span>
        ) : (
          <span>
            <div className="form__checkbox--inactive" onClick={this.handleCheckboxToggle} />
            <input
              placeholder={this.props.placeholder}
              checked={false}
              onChange={this.props.onChange}
              value={this.props.value}
              title={this.props.title}
              name={this.props.name || nameAttr}
              ref={el => (this.inputRef = el)}
              className="form__actual-checkbox"
              aria-label={ariaLabel}
              disabled={this.props.disabled}
            />
          </span>
        )
      ) : this.props.type === 'checkbox-dark' ? (
        this.props.value ? (
          <span>
            <div className="form__checkbox--active-dark" onClick={this.handleCheckboxToggle}>
              <img
                className="form__checkbox-checkmark"
                src={ImageHelper.imageUrl('i/059220a4_a4b7.svg')}
                alt={this.props.altText}
              />
            </div>
            <input
              placeholder={this.props.placeholder}
              checked
              value={this.props.value}
              title={this.props.title}
              name={this.props.name || nameAttr}
              ref={el => (this.inputRef = el)}
              className="form__actual-checkbox"
              aria-label={ariaLabel}
              disabled={this.props.disabled}
            />
          </span>
        ) : (
          <span>
            <div className="form__checkbox--inactive-dark" onClick={this.handleCheckboxToggle} />
            <input
              placeholder={this.props.placeholder}
              checked={false}
              onChange={this.props.onChange}
              value={this.props.value}
              title={this.props.title}
              name={this.props.name || nameAttr}
              ref={el => (this.inputRef = el)}
              className="form__actual-checkbox"
              aria-label={ariaLabel}
              disabled={this.props.disabled}
            />
          </span>
        )
      ) : this.props.type === 'textarea' ? (
        <React.Fragment>
          <textarea
            placeholder={this.props.placeholder}
            value={this.props.value}
            name={this.props.name || nameAttr}
            ref={el => (this.inputRef = el)}
            className={inputClassNames}
            rows={this.props.rows}
            onClick={this.props.onClick}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onChange={this.props.onChange}
            style={this.props.style}
            aria-label={ariaLabel}
            disabled={this.props.disabled}
            maxLength={this.props.maxLength}
          />
          {this.props.warningMessage && (
            <span className="storefront__warning-message">{this.props.warningMessage}</span>
          )}

          {this.props.withCounter && this.props.errorPosition === 'bottom' && (
            <div>
              <div className="form__error--bottom">{this.props.error}</div>
              <p>
                You have {this.props.maxLength - this.props.value.length} of {this.props.maxLength}{' '}
                characters left.
              </p>
            </div>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <input
            autoFocus={this.props.autoFocus}
            placeholder={this.props.placeholder}
            type={this.props.type}
            onClick={this.props.onClick}
            onFocus={this.props.onFocus}
            onChange={this.props.onChange}
            onKeyDown={this.props.onKeyDown}
            onBlur={this.props.onBlur}
            value={this.props.value}
            title={this.props.title}
            selected={this.props.selected}
            checked={this.props.checked}
            disabled={this.props.disabled}
            name={this.props.name || nameAttr}
            ref={el => (this.inputRef = el)}
            id={nameAttr}
            className={inputClassNames}
            style={this.props.style}
            aria-label={ariaLabel}
            pattern={this.props.pattern}
            autoComplete={this.props.autocomplete}
            date-format={this.props.dateFormat}
          />
          {this.props.warningMessage && (
            <span className="storefront__warning-message">{this.props.warningMessage}</span>
          )}
        </React.Fragment>
      )

    const label =
      this.props.label || (this.props.error && this.props.errorPosition === 'top') ? (
        <label className={labelClassNames} htmlFor={nameAttr}>
          {this.props.label}
          {this.props.error != null && this.props.errorPosition === 'top' && (
            <HidePIIFromTrackers>
              <span className={errorClassNames}>{this.props.error}</span>
            </HidePIIFromTrackers>
          )}
        </label>
      ) : undefined

    const content =
      this.props.type === 'radio' || this.props.labelVerticalPosition === 'bottom' ? (
        <div>
          {input}
          {label}
        </div>
      ) : (
        <div>
          {label}
          {input}
          {this.props.error != null &&
            this.props.errorPosition === 'bottom' &&
            !this.props.withCounter && (
              <div className="form__error--bottom">{this.props.error}</div>
            )}
        </div>
      )

    return <fieldset className={fieldsetClassNames}>{content}</fieldset>
  }
}

export default Input
